import { createAsyncThunk } from '@reduxjs/toolkit';
import { chicoryFetcher } from '../../utils';
import { DataTableData } from '../../types';

export type PartnerRawFromAPI = {
  id: number;
  accountId: number;
  createdDate: string;
  email: string;
  paypalEmail?: string;
  excludeFromMarketingEmails: boolean;
  firstName: string;
  lastName: string;
  isPremium: boolean;
  monthlyImpressions: number;
  publishers: { hostname: string; id: number; name: string }[];
  source: string;
  sourceComments: string;
  status: 'pending' | 'approved' | 'rejected';
};

type Unpacked<T> = T extends (infer U)[] ? U : T;
type ApiDataEntry = Unpacked<DataTableData>;

export const formatPartnerUserForDataTable: (
  p: PartnerRawFromAPI
) => ApiDataEntry = (partner) => {
  return {
    id: partner.id,
    name: `${partner.firstName} ${partner.lastName}`,
    email: partner.email,
    paypalEmail: partner.paypalEmail ? partner.paypalEmail : '',
    accountName: partner.accountId ? partner.accountId?.toString() : '',
    domains: partner.publishers?.map((pub) => pub.hostname),
    partnerTier: partner.isPremium ? 'Premium Publisher' : 'Individual Creator',
    monthlyImpressions: partner.monthlyImpressions,
    createdDate: partner.createdDate,
    source: partner.source,
  };
};

export const fetchCurrentPartners = createAsyncThunk<PartnerRawFromAPI[]>(
  'FETCH_CURRENT_PARTNERS',
  async () => {
    const partnerResponse = await chicoryFetcher(
      '/partners?status=approved&limit=10000'
    );
    const partners = await partnerResponse.json();
    return partners.results;
  }
);
